import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchCommodities({ data }) {
  const { search, ...rest } = data;
  Object.keys(search).forEach((key) => {
    if (search[key]?.length < 1 || search[key] === null) delete search[key];
  });

  try {
    // const response = yield axios.get(`${baseURL}/api/v1/activity_types`, {
    const response = yield axios.get(`${baseURL}/commodity`, {
      params: { ...rest, ...(Object.keys(search).length > 0 && { ...search }) },
    });
    if (response.status === 200) {
      yield put(actions.fetchCommoditiesSuccess(response.data.commodities));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchCommoditiesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateCommodity({ data }) {
  const { name, id } = data;
  try {
    const response = yield axios.patch(`${baseURL}/commodity/${id}`, {
      name,
    });
    if (response.status === 200) {
      AntdAlert.success("Commodity updated successfully");
      yield put(actions.updateCommoditySuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateCommodityError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateCommodityError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteCommodity({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(`${baseURL}/commodity/${id}`);

    if (response.status === 200) {
      AntdAlert.success("Commodity deleted successfully");
      yield put(actions.deleteCommoditySuccess(id));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.deleteCommodityError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteCommodityError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateCommodity({ data }) {
  try {
    const response = yield axios.post(`${baseURL}/commodity`, {
      name: data.name,
    });

    console.log(response);
    if (response.status === 201) {
      AntdAlert.success("Commodity created successfully");
      yield put(actions.createCommoditySuccess(response.data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createCommodityError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.createCommodityError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
